import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import { cancelSelectBlueprintAction, createRuleAction } from '../../../state/actions/blueprint';
import {
	getSelectedBlueprintModuleKey,
	isBlueprintDialogOpen,
} from '../../../state/selectors/blueprint';
import type { State } from '../../../state/types';
import SelectBlueprint from './select-blueprint';
import AddRule from './view';

const mapStateToProps = (state: State) => ({
	SelectBlueprintComponent: SelectBlueprint,
	selectedBlueprintKey: getSelectedBlueprintModuleKey(state),
	isOpen: isBlueprintDialogOpen(state),
});

export default connect(mapStateToProps, {
	onContinue: () => {
		triggerAnalyticsEvent('summary.blueprint-dialog.next.clicked');
		return createRuleAction();
	},
	onClose: () => {
		triggerAnalyticsEvent('summary.blueprint-dialog.cancel.clicked');
		return cancelSelectBlueprintAction();
	},
})(AddRule);
